import { BaseComponent } from "../../BaseComponent.js";
import { defineElement } from "../../../decorators/defineElement.js";
import { prop } from "../../../decorators/prop/index.js";
import { css, html } from "lit";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let DsfUploadProgress = class extends BaseComponent {
  constructor() {
    super(...arguments);
    this.dsf_upload_progress = "indeterminate";
  }
  get isIndeterminate() {
    return this.dsf_upload_progress === "indeterminate";
  }
  get uploadProgress() {
    return this.isIndeterminate || !this.dsf_upload_progress ? 50 : Number(this.dsf_upload_progress);
  }
  render() {
    this.style.setProperty("--dsf-upload-progress", `${this.uploadProgress}%`);
    return html`<div class=${`progress ${this.isIndeterminate ? "animate-spin" : ""}`}></div>`;
  }
};
DsfUploadProgress.styles = [
  ...BaseComponent.styles,
  css`
      .progress {
        width: calc(1.4 * var(--dsf-base-size));
        height: calc(1.4 * var(--dsf-base-size));
        border-radius: 50%;
        background: radial-gradient(closest-side, white calc(64% - 1px), transparent 64% 100%),
          conic-gradient(
            rgb(var(--dsf-color-secondary-300)) var(--dsf-upload-progress),
            rgb(var(--dsf-color-neutral-100)) 0
          );
      }
    `
];
__decorateClass([
  prop({ type: String, reflect: true })
], DsfUploadProgress.prototype, "dsf_upload_progress", 2);
DsfUploadProgress = __decorateClass([
  defineElement("dsf-upload-progress")
], DsfUploadProgress);
export {
  DsfUploadProgress
};
